var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailIconPlaid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " alert-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6668 35.6355C34.6668 37.1075 33.4722 38.3021 32.0002 38.3021C30.5282 38.3021 29.3335 37.1075 29.3335 35.6355V22.3021C29.3335 20.8301 30.5282 19.6355 32.0002 19.6355C33.4722 19.6355 34.6668 20.8301 34.6668 22.3021V35.6355ZM32.0002 46.3021C30.5282 46.3021 29.3335 45.1075 29.3335 43.6355C29.3335 42.1635 30.5282 40.9688 32.0002 40.9688C33.4722 40.9688 34.6668 42.1635 34.6668 43.6355C34.6668 45.1075 33.4722 46.3021 32.0002 46.3021ZM32.0002 6.30212C17.2722 6.30212 5.3335 18.2408 5.3335 32.9688C5.3335 47.6968 17.2722 59.6355 32.0002 59.6355C46.7282 59.6355 58.6668 47.6968 58.6668 32.9688C58.6668 18.2408 46.7282 6.30212 32.0002 6.30212Z",
    fill: "#E60808"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailIconPlaid);
export default __webpack_public_path__ + "static/media/failIconPlaid.a405e8f111b34664af991784db35c8b5.svg";
export { ForwardRef as ReactComponent };